module.exports = __webpack_public_path__ + "img/740-e37864.png";